// libs
import React, { memo, useRef, useState } from 'react';

// styles
import { Title, Header, Placeholder, ProductCount, WishlistSpan, Text } from './styles';

// context
import { useWishlistContext } from 'shared/layouts/Wishlist/API/context';
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// helpers
import MeasureWidth from 'shared/components/MeasureWidth';

//components
import IOElement from 'shared/components/IOElement';

// constants
import { MIN_NUMBER_OF_PRODUCTS_TO_SHOW_PRODUCT_COUNT } from 'shared/layouts/Wishlist/Mobile/constants';

const MY = 'My';
const WISHLIST_SPAN_TEXT = '... Wishlist';
const HEADER_PADDING = 40;

//defs
interface IWishlistTitle {
  totalProductsInWishlist: number;
}

function WishlistTitle({ totalProductsInWishlist }: IWishlistTitle) {
  // context
  const { isFetching, wishlistName, firstName, isUserFetching } = useWishlistContext();
  const [showBorder, setShowBorder] = useState<boolean>(false);
  const { deviceWidth } = useResponsiveContext();

  // refs
  const useTotalContainerWidth = useRef(0);
  const [showSpan, setShowSpan] = useState(false);
  const userNameText = isUserFetching ? '' : firstName != '' ? `${firstName}'s` : MY;

  const handleOnMeasured = (width: number) => {
    if (width >= (deviceWidth - HEADER_PADDING) * 2) {
      setShowSpan(true);
    }

    useTotalContainerWidth.current = width;
  };

  if (isUserFetching) return <Placeholder />;
  return (
    <>
      <IOElement
        onVisible={() => setShowBorder(false)}
        onHidden={() => setShowBorder(true)}
        data-test="wishlist-io"
      />

      {totalProductsInWishlist === 0 && isFetching && <Placeholder />}
      <MeasureWidth onMeasured={handleOnMeasured}>
        <Text>{`${userNameText} ${wishlistName}`}</Text>
      </MeasureWidth>
      {totalProductsInWishlist !== 0 && (
        <Header showBorder={showBorder}>
          <Title>
            {useTotalContainerWidth && useTotalContainerWidth.current > 0 && (
              <Text totalContainerWidth={useTotalContainerWidth.current}>
                {`${userNameText} ${wishlistName}`}
              </Text>
            )}

            {showSpan && <WishlistSpan>{WISHLIST_SPAN_TEXT}</WishlistSpan>}
          </Title>
          {totalProductsInWishlist > MIN_NUMBER_OF_PRODUCTS_TO_SHOW_PRODUCT_COUNT && (
            <ProductCount>{`${totalProductsInWishlist} items`}</ProductCount>
          )}
        </Header>
      )}
    </>
  );
}
export default memo(WishlistTitle);
